import { DataSource } from '@client/core/data/concerns/data-source';
import { HttpResponse } from '@client/core/http/types';
import { SetupIntent } from '@stripe/stripe-js';

export class PaymentInformationDataSource extends DataSource {
  async store(ownerId: number, paymentMethod: string): Promise<void> {
    await this.httpClient.post<HttpResponse<void>>(`/workspace/${ownerId}/billing/update-payment-information`, {
      token: paymentMethod,
    });
  }

  async createSetupIntent(ownerId: number): Promise<SetupIntent> {
    const response = await this.httpClient.post<HttpResponse<SetupIntent>>(
      `/workspace/${ownerId}/billing/create-setup-intent`,
    );

    return response.data.data;
  }
}
